export default __webpack_public_path__ + "static/bird-b8bd8e38624600550f5d058e9c9b1529.jpg";